export default __webpack_public_path__ + "static/media/box-white-paper-thin.b2acf2d5.jpg";